import validator from 'validator';

const validateEditTalent = (data) => {
    let errors = {};

    const { sub_type,
        validity_date,
        original_price,
        discount,
        
        no_of_cases } = data;

        if (validator.isEmpty(sub_type)) {
            errors.sub_type = '필수 입력 사항입니다.';
        }
        if (!validity_date) {
            errors.validity_date = '필수 입력 사항입니다.';
        }
    
        if (!original_price) {
            errors.original_price = '필수 입력 사항입니다.';
        }
        // else if (!validator.isNumeric(original_price)) {
        //     errors.original_price = 'Only numeric values';
        // }
        if (!discount) {
            errors.discount = '필수 입력 사항입니다.';
        }
        // else if (!validator.isNumeric(discount)) {
        //     errors.discount = 'Only numeric values';
        // }
        // if (!discounted_price) {
        //     errors.discounted_price = '필수 입력 사항입니다.';
        // }
        // else if (!validator.isNumeric(discounted_price)) {
        //     errors.discounted_price = 'Only numeric values';
        // }
        if (!no_of_cases) {
            errors.no_of_cases = '필수 입력 사항입니다.';
        }
        // else if (!validator.isNumeric(no_of_cases)) {
        //     errors.no_of_cases = 'Only numeric values';
        // }
    // if (validator.isEmpty(file)) {
    //     errors.file = '파일을 업로드 해주세요';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateEditTalent;